import React from 'react';

import PropTypes from 'prop-types';

import { i18nMoment } from 'wanderu-i18n';

import {
    POINT_RADIUS,
    TEXT_VERTICAL_OFFSET,
} from '../constants';

import styles from './HorizontalAxis.scss';

const propTypes = {
    columnWidth: PropTypes.number.isRequired,
    data: PropTypes.object.isRequired,
    height: PropTypes.number.isRequired,
    isLineGraph: PropTypes.bool,
    values: PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
        ]),
    ).isRequired,
    labelType: PropTypes.oneOf(['date', 'number']),
};
const defaultProps = {
    isLineGraph: false,
    labelType: 'date',
};

function HorizontalAxis(props) {
    const {
        columnWidth,
        data,
        height,
        isLineGraph,
        labelType,
        values,
    } = props;

    return (
        <svg>
            {values.map((key) => {
                const point = data[key];
                let label = point.xVal;

                if (labelType === 'date') {
                    label = typeof label === 'number'
                        ? i18nMoment(label, 'M').format('MMM')[0]
                        : i18nMoment(label).format('MMM');
                }

                return point && (
                    <text
                        className={styles.label}
                        key={point.xVal}
                        x={isLineGraph
                            ? point.xCoord - POINT_RADIUS
                            : point.xCoord + columnWidth / 4}
                        y={height + TEXT_VERTICAL_OFFSET}
                    >
                        {label}
                    </text>
                );
            })}
        </svg>
    );
}

HorizontalAxis.propTypes = propTypes;
HorizontalAxis.defaultProps = defaultProps;

export default HorizontalAxis;
